import React, {ChangeEvent, useState} from 'react';
import b_ from 'b_';

import BlockInput from 'client/common/components/block-input';

import I18N from 'assets/i18n/brandlift-project';
import {useCanEditSurveySettings} from 'client/common/hooks/edit-mode';
import {useSurveySlug} from 'client/common/contexts/slug';
import {useSurveySettings, useUpdateSurveySettings} from 'client/common/hooks/survey';
import DebouncedTextInput from 'client/common/components/debounced-text-input';

const i18n = I18N.common.surveySettings.editSettingsModal;

const b = b_.with('survey-settings');

interface SurveyRedirectProps {
    mix?: string;
}

export default function SurveyRedirect(props: SurveyRedirectProps) {
    const {mix} = props;

    const canEdit = useCanEditSurveySettings();
    const slug = useSurveySlug();
    const settings = useSurveySettings();
    const onUpdate = useUpdateSurveySettings(slug);

    const [redirect, setRedirect] = useState(settings?.redirects.default);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const newRedirect = event.target.value;

        setRedirect(newRedirect);
    };

    const handleRedirectChange = () => {
        if (settings?.redirects.default !== redirect) {
            void onUpdate({
                ...(redirect !== undefined && {redirects: {default: redirect}})
            });
        }
    };

    const className = `${b('input-wrapper')} ${mix};`;

    return (
        <BlockInput
            className={className}
            title={i18n.surveyComplete}
            description={i18n.redirectAfterComplete}
        >
            <DebouncedTextInput
                className={b('input-control')}
                disabled={!canEdit}
                callback={handleRedirectChange}
                onChange={handleChange}
                placeholder={i18n.redirect.placeholder}
                size='m'
                value={redirect}
                view='dl'
            />
        </BlockInput>
    );
}
